export default function IconTallyAddon() {
  return (
    <svg
      viewBox="0 0 40 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"      
      
    >
      <g id="Group">
        <path
          id="Vector"
          d="M0 30.0172C0 31.2972 1.04 32.3372 2.32 32.3372H18.01V25.0872H17.35C15.71 25.0872 14.37 23.7472 14.37 22.1072V18.3572C14.37 18.1772 14.52 18.0272 14.7 18.0272H15.69V14.4972C15.69 13.7472 16.3 13.1372 17.05 13.1372C17.8 13.1372 18.41 13.7472 18.41 14.4972V18.0272H20.66V14.4972C20.66 13.7472 21.27 13.1372 22.02 13.1372C22.77 13.1372 23.38 13.7472 23.38 14.4972V18.0272H24.37C24.55 18.0272 24.7 18.1772 24.7 18.3572V22.1072C24.7 23.7472 23.36 25.0872 21.72 25.0872H21.06V32.3372H36.75C38.03 32.3372 39.07 31.2972 39.07 30.0172V10.1172H0V30.0172Z"          
        ></path>
        <path
          id="Vector_2"
          d="M36.74 0H2.32C1.04 0 0 1.04 0 2.32V9.47H39.06V2.32C39.06 1.04 38.02 0 36.74 0ZM5.05 6.85C3.89 6.85 2.94 5.9 2.94 4.74C2.94 3.58 3.89 2.63 5.05 2.63C6.21 2.63 7.16 3.58 7.16 4.74C7.16 5.9 6.21 6.85 5.05 6.85ZM11.21 6.85C10.04 6.85 9.1 5.9 9.1 4.74C9.1 3.58 10.05 2.63 11.21 2.63C12.37 2.63 13.32 3.58 13.32 4.74C13.32 5.9 12.37 6.85 11.21 6.85ZM34.44 6.43H17.9C16.97 6.43 16.21 5.67 16.21 4.74C16.21 3.81 16.97 3.05 17.9 3.05H34.44C35.37 3.05 36.13 3.81 36.13 4.74C36.13 5.67 35.37 6.43 34.44 6.43Z"          
        ></path>
        <path
          id="Vector_3"
          d="M5.0501 3.28125C4.2501 3.28125 3.6001 3.93125 3.6001 4.73125C3.6001 5.53125 4.2501 6.18125 5.0501 6.18125C5.8501 6.18125 6.5001 5.53125 6.5001 4.73125C6.5001 3.93125 5.8501 3.28125 5.0501 3.28125Z"          
        ></path>
        <path
          id="Vector_4"
          d="M11.2098 3.28125C10.4098 3.28125 9.75977 3.93125 9.75977 4.73125C9.75977 5.53125 10.4098 6.18125 11.2098 6.18125C12.0098 6.18125 12.6598 5.53125 12.6598 4.73125C12.6598 3.93125 12.0098 3.28125 11.2098 3.28125Z"          
        ></path>
        <path
          id="Vector_5"
          d="M34.4401 3.70312H17.9001C17.3301 3.70312 16.8701 4.16312 16.8701 4.73312C16.8701 5.30312 17.3301 5.76312 17.9001 5.76312H34.4401C35.0101 5.76312 35.4701 5.30312 35.4701 4.73312C35.4701 4.16312 35.0101 3.70312 34.4401 3.70312Z"          
        ></path>
        <path
          id="Vector_6"
          d="M18.6699 25.0938H20.3899V32.3438H18.6699V25.0938Z"          
        ></path>
        <path
          id="Vector_7"
          d="M24.0298 22.1075V18.6875H15.0298V22.1075C15.0298 23.3875 16.0698 24.4275 17.3498 24.4275H21.7198C22.9998 24.4275 24.0398 23.3875 24.0398 22.1075H24.0298Z"          
        ></path>
        <path
          id="Vector_8"
          d="M17.0501 13.7969C16.6601 13.7969 16.3501 14.1069 16.3501 14.4869V18.0169H17.7501V14.4869C17.7501 14.1069 17.4401 13.7969 17.0601 13.7969H17.0501Z"          
        ></path>
        <path
          id="Vector_9"
          d="M22.0098 13.7969C21.6298 13.7969 21.3198 14.1069 21.3198 14.4869V18.0169H22.7198V14.4869C22.7198 14.1069 22.4098 13.7969 22.0198 13.7969H22.0098Z"          
        ></path>
      </g>
    </svg>
  );
}
